/* Vandermeer Gardens: visitor's passport, wander button, sort control */
(function () {
  var KEY = 'vg-passport-v1';
  var ROOMS = ['fountain', 'statuary', 'topiary', 'conservatory', 'allee'];

  function readStamps() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function writeStamps(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function init() {
    var rail = document.querySelector('[data-vg-rail]');
    if (!rail) return;

    var current = rail.getAttribute('data-vg-current');
    var stamps = readStamps();
    if (current && ROOMS.indexOf(current) !== -1 && stamps.indexOf(current) === -1) {
      stamps.push(current);
      writeStamps(stamps);
    }

    var count = 0;
    rail.querySelectorAll('[data-vg-stamp]').forEach(function (el) {
      if (stamps.indexOf(el.getAttribute('data-vg-stamp')) !== -1) {
        el.classList.add('is-stamped');
        count += 1;
      }
    });

    var countEl = rail.querySelector('[data-vg-count]');
    if (countEl) {
      countEl.textContent = count >= ROOMS.length
        ? countEl.getAttribute('data-vg-done')
        : count + ' of ' + ROOMS.length + ' rooms visited';
    }

    var wander = rail.querySelector('[data-vg-wander]');
    if (wander) {
      wander.addEventListener('click', function () {
        var links = Array.prototype.slice.call(rail.querySelectorAll('[data-vg-room-link]'));
        var pool = links.filter(function (a) {
          var key = a.getAttribute('data-vg-room-link');
          return key !== current && stamps.indexOf(key) === -1 && a.getAttribute('data-vg-open') === 'true';
        });
        if (!pool.length) {
          pool = links.filter(function (a) {
            return a.getAttribute('data-vg-room-link') !== current && a.getAttribute('data-vg-open') === 'true';
          });
        }
        if (pool.length) {
          window.location.href = pool[Math.floor(Math.random() * pool.length)].href;
        }
      });
    }
  }

  function initSort() {
    document.querySelectorAll('[data-vg-sort]').forEach(function (select) {
      select.addEventListener('change', function () {
        if (select.form) select.form.submit();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); initSort(); });
  } else {
    init();
    initSort();
  }
})();
